module.exports = __webpack_public_path__ + "img/41_7.89a8c510.png";